
<div class="table-container mat-elevation-z8" >
    <table mat-table matSort [dataSource]="fetchedGroups" matSortActive="name" matSortDirection="asc" aria-describedby="groups-table">
      <ng-container matColumnDef="group">
        <th id="group" mat-header-cell *matHeaderCellDef mat-sort-header>{{data.Username}} - Group</th>
        <td  mat-cell *matCellDef="let group"> {{group}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedGroupsColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedGroupsColumns;"></tr>
    </table>
  </div>

<div class="card"  *ngIf = "isUserNull">
    <div class="card-body">
<strong>{{data.Username}}</strong> does not belong to any group!
</div>
</div>

<div class="buttonClass mt-2">
<button mat-raised-button (click)="onClose()">Close</button>
</div>